import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { reconcileRolePages, ROLE_PAGE_ITEMS } from "../../utils/rolePagesMigration";

const pageNameMapping = {
  "Patient Birthday": "Patients",
};

const routeRules = [
  { pattern: /^\/dashboard$/, page: "Dashboard" },
  { pattern: /^\/roles(?:\/|$)/, page: "Roles" },
  { pattern: /^\/users$/, page: "Users" },
  { pattern: /^\/hr-management\/staff(?:\/|$)/, page: "Staff" },
  { pattern: /^\/hr-management\/department$/, page: "Department" },
  { pattern: /^\/hr-management\/attendance(?:\/|$)/, page: "Attendance" },
  { pattern: /^\/hr-management\/shift$/, page: "Shift" },
  { pattern: /^\/hr-management\/leave$/, page: "Leave Management" },
  { pattern: /^\/hr-management\/salary-details(?:\/|$)/, page: "Salary Details" },
  { pattern: /^\/hr-management\/holiday$/, page: "Holiday" },
  { pattern: /^\/doctors$/, page: "Doctors" },
  { pattern: /^\/fees-management\/treatment_charges$/, page: "Treatment Charges" },
  { pattern: /^\/fees-management\/doctorfee_master$/, page: "Doctor Fee Master" },
  { pattern: /^\/fees-management(?:\/|$)/, page: "Treatment Charges" },
  { pattern: /^\/patients\/yoga-patients$/, page: "Yoga Patients" },
  { pattern: /^\/patients\/homeopathy-patients$/, page: "Homeopathy Patients" },
  { pattern: /^\/patients\/patient-birthday$/, page: "Patients" },
  { pattern: /^\/patients(?:\/|$)/, page: "Patients" },
  { pattern: /^\/appointments(?:\/|$)/, page: "Appointments" },
  { pattern: /^\/follow-up-calls\/follow-up-1$/, page: "Follow-up 1" },
  { pattern: /^\/follow-up-calls\/follow-up-2$/, page: "Follow-up 2" },
  { pattern: /^\/follow-up-calls\/courtesy-call$/, page: "Courtesy Call" },
  { pattern: /^\/follow-up-calls$/, page: "Courtesy Call" },
  { pattern: /^\/billing\/out-billing(?:\/|$)/, page: "OUT Billing" },
  { pattern: /^\/pharmacy\/medicine-master$/, page: "Medicine List" },
  { pattern: /^\/pharmacy\/prescription$/, page: "Prescription" },
  { pattern: /^\/pharmacy\/purchase-order(?:\/|$)/, page: "Purchase Order" },
  { pattern: /^\/pharmacy\/purchase-pharmacy(?:\/|$)/, page: "Purchase List" },
  { pattern: /^\/pharmacy\/sale-pharmacy(?:\/|$)/, page: "Sale Pharmacy" },
  { pattern: /^\/pharmacy\/stock-management$/, page: "Stock Management" },
  { pattern: /^\/pharmacy\/supplier$/, page: "Supplier" },
  { pattern: /^\/pharmacy\/reports$/, page: "Reports Pharmacy" },
  { pattern: /^\/lab-management(?:\/|$)/, page: "Lab Management" },
  { pattern: /^\/add-lab-management$/, page: "Lab Management" },
  { pattern: /^\/update-lab-management\//, page: "Lab Management" },
  { pattern: /^\/expenses$/, page: "Expenses" },
  { pattern: /^\/hospital-maintenance$/, page: "Hospital Maintenance" },
  { pattern: /^\/hospital-purchases(?:\/|$)/, page: "Hospital Purchases" },
  { pattern: /^\/chat$/, page: "Chat" },
  { pattern: /^\/reports$/, page: "Reports" },
];

const publicAuthenticatedRoutes = new Set([
  "/notifications",
  "/profile",
  "/messages",
  "/settings",
]);

function getRule(pathname) {
  return routeRules.find((rule) => rule.pattern.test(pathname));
}

function hasPageAccess(pageName) {
  const rawPages = localStorage.getItem("role_pages");
  if (!rawPages) return false;

  try {
    const pages = JSON.parse(rawPages);
    const reconciled = reconcileRolePages(pages, ROLE_PAGE_ITEMS);
    const page = reconciled.find(
      (item) => (pageNameMapping[item.page] || item.page) === pageName
    );
    return page?.access === true || page?.priviallages?.all === true;
  } catch (error) {
    console.error("Unable to read role permissions:", error);
    return false;
  }
}

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  // Detail/print routes are reached from already-authorized pages and are kept
  // authenticated without introducing new permission names or changing flow.
  if (publicAuthenticatedRoutes.has(location.pathname)) {
    return children;
  }

  const rule = getRule(location.pathname);
  if (!rule || hasPageAccess(rule.page)) {
    return children;
  }

  return <Navigate to="/dashboard" replace />;
}
